<isophi-info-popup
  *transloco="let t"
  [title]="t('settings/popup/title')"
  [continueLabel]="t('settings/popup/continue')"
  [(dontShowAgain)]="dontShowAgain"
  (closed)="close()"
>
  <img src="../../../../../assets/img/foto/isophi-skolicka-326.jpg" alt="" />
  <div class="text-wrapper">
    <div [innerHTML]="t('settings/popup/text1')"></div>
    <div [innerHTML]="t('settings/popup/text2')"></div>
    <div [innerHTML]="t('shared/popup/contact')"></div>
  </div>
</isophi-info-popup>
